import(/* webpackMode: "eager" */ "/stage-regression/app/global-error.tsx")